export enum EZastupujeOsoba {
    FYZOSOBA_VYPIS = 'FODVR',
    FYZOSOBA_PLNAMOC = 'FOZPM',
    FYZOSOBA_JINEOPRAV = 'FOZJO',
    PRAVOSOBA_VYPIS = 'PODVR',
    PRAVOSOBA_PLNAMOC = 'POZPM'
}
